import { render } from "./DaysOffReports.vue?vue&type=template&id=483e440a&scoped=true"
import script from "./DaysOffReports.vue?vue&type=script&lang=js"
export * from "./DaysOffReports.vue?vue&type=script&lang=js"

import "./DaysOffReports.vue?vue&type=style&index=0&id=483e440a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483e440a"]])

export default __exports__